import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { fetchMonitoringOverviewHistory } from '../services/dmMonitoringOverviewHistory';
import { authorTimeZone } from '../utils/eventDateTime';
import type { RangeKey } from './useBillingRange';
import { MONITORING_OVERVIEW_HISTORY_KEY } from './queryKeys';

// The server caches each range for five minutes, so polling faster would only re-read its cache.
const HISTORY_STALE_MS = 5 * 60_000;

export function useMonitoringOverviewHistory(range: RangeKey) {
    const [tz] = useState(authorTimeZone);
    const { data, isFetching, isError, isPlaceholderData, refetch } = useQuery({
        queryKey: MONITORING_OVERVIEW_HISTORY_KEY(range, tz),
        queryFn: () => fetchMonitoringOverviewHistory(range, tz),
        staleTime: HISTORY_STALE_MS,
        placeholderData: keepPreviousData
    });
    return {
        history: data ?? null,
        // True only while a newly picked range loads behind the previous range's data.
        isSwitching: isFetching && isPlaceholderData,
        isError,
        retry: refetch
    };
}
